import { render, staticRenderFns } from "./GSUser.vue?vue&type=template&id=ef1f75f2&scoped=true&"
var script = {}
import style0 from "./GSUser.vue?vue&type=style&index=0&id=ef1f75f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef1f75f2",
  null
  
)

export default component.exports